import { render } from "./contrats.vue?vue&type=template&id=74ec5502"
import script from "./contrats.vue?vue&type=script&lang=ts"
export * from "./contrats.vue?vue&type=script&lang=ts"
script.render = render

export default script